import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  ComboboxItem,
  Fieldset,
  Flex,
  Grid,
  Select,
  TextInput,
} from "@mantine/core";
import { IconCheck, IconMapPin, IconTransform } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import {
  getCommuneSelect,
  getCommuneSelectNew,
  getDistrictSelect,
  getProvinceSelect,
  getProvinceSelectNew,
} from "../../../service/getSelectApi";
import { repositoryMdm } from "../../../_base/_const/_constVar";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";
import { modals } from "@mantine/modals";

interface DataAddressOld {
  provinceId: string;
  districtId: string;
  communeId: string;
}

interface DataAddressNew {
  provinceNewId: string;
  communeNewId: string;
}

const CreateAddressConversion = ({
  onSuccess,
  data,
}: {
  onSuccess: any;
  data: any;
}) => {
  const [dataAddressOld, setDataAddressOld] = useState<DataAddressOld>({
    provinceId: String(data?.idProvince),
    districtId: String(data?.idDistrict),
    communeId: String(data?.id),
  });

  const [dataAddressNew, setDataAddressNew] = useState<DataAddressNew>({
    provinceNewId: data?.newProvinceId ? String(data?.newProvinceId) : "",
    communeNewId: data?.newCommuneId ? String(data?.newCommuneId) : "",
  });

  const [dataProvinceSelect, setDataProvinceSelect] = useState<ComboboxItem[]>(
    []
  );
  const [dataDistrictSelect, setDataDistrictSelect] = useState<ComboboxItem[]>(
    []
  );
  const [dataCommuneSelect, setDataCommuneSelect] = useState<ComboboxItem[]>(
    []
  );
  const [dataProvinceNewSelect, setDataProvinceNewSelect] = useState<
    ComboboxItem[]
  >([]);
  const [dataCommuneNewSelect, setDataCommuneNewSelect] = useState<
    ComboboxItem[]
  >([]);

  const fetchDataProvince = async () => {
    const res = await getProvinceSelect();

    if (res) {
      const data = res
        ?.filter((item: any) => item.text && item.value)
        ?.map((item: any) => ({
          label: String(item.text),
          value: String(item.value),
        }));
      setDataProvinceSelect(data);
    }
  };

  const fetchDataDistrict = async (id: string) => {
    const res = await getDistrictSelect(id);

    if (res) {
      const data = res
        ?.filter((item: any) => item.text && item.value)
        ?.map((item: any) => ({
          label: String(item.text),
          value: String(item.value),
        }));
      setDataDistrictSelect(data);
    }
  };

  const fetchDataCommune = async (id: string) => {
    const res = await getCommuneSelect(id);

    if (res) {
      const data = res
        ?.filter((item: any) => item.text && item.value)
        ?.map((item: any) => ({
          label: String(item.text),
          value: String(item.value),
        }));
      setDataCommuneSelect(data);
    }
  };

  const fetchDataProvinceNew = async () => {
    const res = await getProvinceSelectNew();

    if (res) {
      setDataProvinceNewSelect(
        res
          ?.filter((item) => item.id && item.name)
          ?.map((item) => ({
            value: String(item.id),
            label: String(item.name),
          }))
      );
    }
  };

  const fetchDataCommuneNew = async (id: string) => {
    const res = await getCommuneSelectNew(id);

    if (res) {
      setDataCommuneNewSelect(
        res
          ?.filter((item) => item.text && item.value)
          ?.map((item) => ({
            value: String(item.value),
            label: String(item.text),
          }))
      );
    }
  };

  const handleSubmit = async () => {
    const res = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblDmCustomer/update-new-commune",
      {
        oldCommuneId: Number(dataAddressOld.communeId),
        newCommuneId: Number(dataAddressNew.communeNewId),
        newProvinceId: Number(dataAddressNew.provinceNewId),
      }
    );

    if (res && res.success) {
      NotificationExtension.Success("Tạo mới thành công !");
      setTimeout(() => {
        onSuccess();
        modals.closeAll();
      }, 1000);
    }
  };

  useEffect(() => {
    fetchDataProvince();
    fetchDataProvinceNew();
  }, []);

  useEffect(() => {
    if (dataAddressOld.provinceId && dataAddressOld.provinceId.length > 0) {
      fetchDataDistrict(dataAddressOld.provinceId);
    }
  }, [dataAddressOld.provinceId]);

  useEffect(() => {
    if (dataAddressOld.districtId && dataAddressOld.districtId.length > 0) {
      fetchDataCommune(dataAddressOld.districtId);
    }
  }, []);

  useEffect(() => {
    if (
      dataAddressNew.provinceNewId &&
      dataAddressNew.provinceNewId.length > 0
    ) {
      fetchDataCommuneNew(dataAddressNew.provinceNewId);
    }
  }, [dataAddressNew.provinceNewId]);

  return (
    <Box maw={1100} w={"60vw"}>
      <Grid mt={10}>
        <Grid.Col span={{ base: 12, lg: 6.5 }}>
          <Fieldset legend="Địa chỉ (Trước khi sáp nhập tỉnh)">
            <Grid>
              <Grid.Col span={{ base: 12, lg: 6 }}>
                <Select
                  label="Tỉnh/TP"
                  placeholder="Nhập tỉnh/thành phố"
                  data={dataProvinceSelect}
                  value={dataAddressOld.provinceId}
                  searchable
                  clearable
                  onChange={(e) => {
                    setDataAddressOld({
                      provinceId: e ? e : "",
                      districtId: "",
                      communeId: "",
                    });
                  }}
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                />
              </Grid.Col>
              <Grid.Col span={{ base: 12, lg: 6 }}>
                <Select
                  label="Quận/huyện"
                  placeholder="Nhập quận/huyện"
                  data={dataDistrictSelect}
                  value={
                    dataAddressOld.districtId &&
                    dataAddressOld.districtId.length > 0
                      ? dataAddressOld.districtId
                      : null
                  }
                  disabled={dataAddressOld.provinceId.length === 0}
                  searchable
                  clearable
                  onChange={(e) => {
                    setDataAddressOld((prev) => ({
                      ...prev,
                      districtId: e ? e : "",
                      communeId: "",
                    }));
                  }}
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <Select
                  label="Phường/xã"
                  placeholder="Nhập phường/xã"
                  data={dataCommuneSelect}
                  value={
                    dataAddressOld.communeId &&
                    dataAddressOld.communeId.length > 0
                      ? dataAddressOld.communeId
                      : null
                  }
                  disabled={dataAddressOld.districtId.length === 0}
                  searchable
                  clearable
                  onChange={(e) => {
                    setDataAddressOld((prev) => ({
                      ...prev,
                      communeId: e ? e : "",
                    }));
                  }}
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                />
              </Grid.Col>
              {/* <Grid.Col span={{ base: 12, lg: 6 }}>
                <TextInput
                  label="Địa chỉ cụ thể"
                  placeholder="Nhập địa chỉ cụ thể"
                  onChange={(e) =>
                    setDataAddressOld((prev) => ({
                      ...prev,
                      address: e.currentTarget.value,
                    }))
                  }
                />
              </Grid.Col> */}
            </Grid>
          </Fieldset>
        </Grid.Col>
        <Grid.Col span={{ base: 12, lg: 1 }}>
          <Flex justify={"center"} align={"center"} h={"100%"}>
            <AvatarGroup>
              <Avatar variant="filled" radius="xl" color="blue" size={"50px"}>
                <IconMapPin />
              </Avatar>
              <Avatar variant="filled" radius="xl" color="blue" size={"50px"}>
                <IconTransform />
              </Avatar>
            </AvatarGroup>
          </Flex>
        </Grid.Col>
        <Grid.Col span={{ base: 12, lg: 4.5 }}>
          <Fieldset legend="Địa chỉ (Sau khi sáp nhập tỉnh)">
            <Grid>
              <Grid.Col span={12}>
                <Select
                  label="Tỉnh/TP"
                  placeholder="Nhập tỉnh/thành phố"
                  data={dataProvinceNewSelect}
                  value={dataAddressNew.provinceNewId}
                  searchable
                  clearable
                  onChange={(e) => {
                    setDataAddressNew((prev) => ({
                      ...prev,
                      provinceNewId: e ? e : "",
                      communeNewId: "",
                    }));
                  }}
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                />
              </Grid.Col>
              <Grid.Col span={12}>
                <Select
                  label="Phường/xã"
                  placeholder="Nhập phường/xã"
                  data={dataCommuneNewSelect}
                  value={
                    dataAddressNew.communeNewId &&
                    dataAddressNew.communeNewId.length > 0
                      ? dataAddressNew.communeNewId
                      : null
                  }
                  disabled={dataAddressNew.provinceNewId.length === 0}
                  searchable
                  clearable
                  onChange={(e) => {
                    setDataAddressNew((prev) => ({
                      ...prev,
                      communeNewId: e ? e : "",
                    }));
                  }}
                  nothingFoundMessage="Không tìm thấy dữ liệu !"
                />
              </Grid.Col>
              {/* <Grid.Col span={12}>
                <TextInput
                  label="Địa chỉ cụ thể"
                  placeholder="Nhập địa chỉ cụ thể"
                  onChange={(e) =>
                    setDataAddressNew((prev) => ({
                      ...prev,
                      address: e.currentTarget.value,
                    }))
                  }
                />
              </Grid.Col> */}
            </Grid>
          </Fieldset>
        </Grid.Col>
      </Grid>
      <Flex justify={"end"}>
        <Button
          leftSection={<IconCheck />}
          color="teal"
          onClick={() => handleSubmit()}
        >
          Lưu
        </Button>
      </Flex>
    </Box>
  );
};

export default CreateAddressConversion;
